import {html, css, LitElement} from 'lit';


export class DzXEvent extends LitElement {

    static properties = {
        root:       {type: String},
        detail:     {type: String},
        eventHide:  {type: String},
        eventShow:  {type: String},
    }


    connectedCallback() {
        super.connectedCallback()
        this.observer = new IntersectionObserver(this.intersection, {
            root: document.getElementById(this.root),
            rootMargin: "0px",
            threshold: 1.0,
        });
        this.observer.observe(this)
    }

    intersection(entries, observer) {
        if (entries[0].intersectionRect.width) {
            let evt = new CustomEvent("toggle", {bubbles: true, composed: true, detail: "show"})
            entries[0].target.dispatchEvent(evt)
        } else {
            let evt = new CustomEvent("toggle", {bubbles: true, composed: true, detail: "hide"})
            entries[0].target.dispatchEvent(evt)
        }
    }


    static styles = css`
        :root {
            display: block;
            width: 2px;
            height: 2px;
        }
    `
    
}

customElements.define('dz-x-event', DzXEvent)